module.exports = __webpack_public_path__ + "static/media/oracle-db.237d0e26.png";